/* Rquiere de mixin.js */

var trackingShippingRequest = {
	data () {
		return {
			listTrackingsShippingRequest: [],
			methods: {
				trackingsShippingRequestGet: 'trackingsShippingRequest',
			},
			paginationListTrackingsShippingRequest: []
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllTrackingsShippingRequest(page = 1) {
			let parameters = '?search=' + this.searchShippingsRequest + '&page=' + page
			let url = this.getApiBackend + this.methods.trackingsShippingRequestGet + parameters
			this.$emit('showLockScreen', 'Obteniendo Segumientos de las Solicitudes de envío . . .')
			this.axiosActionIS(url, 'GET', 'getAllTrackingsShippingRequestResult')
		},
		resultAxiosLocalTrackingsShippingRequest(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllTrackingsShippingRequestResult': this.getAllTrackingsShippingRequestResult(response); break;
			}
		},
		getAllTrackingsShippingRequestResult(response) {
			if(response.data.success == true) {
				this.listTrackingsShippingRequest = response.data.data
				this.paginationListTrackingsShippingRequest = response.data.paginate
			}
			this.getAllTrackingsShippingRequestResultLocal(response)
		},
		getAllTrackingsShippingRequestResultLocal(response) {
			console.log('getAllTrackingsShippingRequestResultLocal no desarrollado', response)
		}

	},
};

export default trackingShippingRequest;